var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useId, useMemo } from 'react';
import { FilespaceStatus } from '@lucidlink/dto/validation';
import { Box, Button, FloatingBox, InlineImage, Modal, Trans, Typography, } from '@lucidlink/uicore';
import { FilespaceDetailsMenuTrigger, filespaceIconDisconnectedImage, filespaceIconUpgradingImage, NOTIFICATION_EVENT_ACTIONS, PII_MASK_CLASS, useFilespaceById, useFilespaceCapabilities, } from '@lucidlink/workspacemanagement';
import { buildNotificationEventUrl, setWindowLocation } from '#services';
import { FilespaceDetailsMenu, FilespaceDetailsWebModalTable, } from './components';
export const FilespaceDetailsWebModal = ({ closeModal, filespace: filespaceDataFromList, }) => {
    _react_refresh_temp_2();
    const { query: { data: filespaceData, isError: isErrorFilespaceApi }, } = useFilespaceById(filespaceDataFromList.workspaceId, filespaceDataFromList?.id);
    const filespace = !filespaceData || isErrorFilespaceApi
        ? filespaceDataFromList
        : filespaceData;
    const { data: { canUpgrade }, } = useFilespaceCapabilities({
        workspaceId: filespace.workspaceId,
        filespace,
    });
    const desktopEventWindowLocation = buildNotificationEventUrl(NOTIFICATION_EVENT_ACTIONS.OpenFilespace, {
        workspaceId: filespace.workspaceId,
        filespaceId: filespace.id,
    });
    const filespaceStatus = filespace.status;
    const titleId = useId();
    const getContextMenuContent = () => {
        if (filespaceStatus === FilespaceStatus.READY ||
            filespaceStatus === FilespaceStatus.SETUP_IN_PROGRESS ||
            filespaceStatus === FilespaceStatus.SUSPEND_IN_PROGRESS ||
            filespaceStatus === FilespaceStatus.UNSUSPEND_IN_PROGRESS ||
            filespaceStatus === FilespaceStatus.ERRORED ||
            filespaceStatus === FilespaceStatus.SETUP_ERROR ||
            filespaceStatus === FilespaceStatus.SUSPEND_ERROR ||
            filespaceStatus === FilespaceStatus.UNSUSPEND_ERROR) {
            return (_jsx(FilespaceDetailsMenu, { closeModal: closeModal, filespace: filespace }));
        }
        return _jsx(_Fragment, {});
    };
    const filespaceImageSrc = useMemo(() => {
        if (filespace.isMigrating) {
            return filespaceIconUpgradingImage;
        }
        return filespaceIconDisconnectedImage;
    }, [filespace.isMigrating]);
    return (_jsxs(Modal, { "aria-labelledby": titleId, closeModal: closeModal, "data-testid": `filespace-details-${filespace.id}`, modalWidth: "m", children: [_jsx(Typography, { "data-testid": "filespace-connection-status", fontWeight: "bold", id: titleId, kind: "subtitle", children: _jsx(Trans, { children: "Filespace details" }) }), _jsxs(Box, { gap: "m", justify: "between", children: [_jsxs(Box, { align: "center", gap: "m", children: [_jsx(InlineImage, { "data-testid": "filespace-icon", height: "32px", src: filespaceImageSrc, width: "32px" }), _jsx(Typography, { className: PII_MASK_CLASS, color: "accent", "data-testid": "filespace-name", fontWeight: "bold", kind: "generic-small", children: filespace.name })] }), !filespace.isMigrating && (_jsx(FloatingBox, { Content: getContextMenuContent(), "data-testid": "filespace-menu", placement: "bottom-start", renderTrigger: FilespaceDetailsMenuTrigger, stopEventPropagation: true, trackFloatingBoxState: () => true }))] }), !filespace.isMigrating && (_jsx(Box, { children: _jsx(Button, { "data-testid": "open-in-desktop-app-button", isFullWidth: true, kind: "primary", onClick: () => {
                        setWindowLocation(desktopEventWindowLocation);
                        closeModal();
                    }, size: "big", children: _jsx(Trans, { children: "Open in desktop app" }) }) })), _jsx(FilespaceDetailsWebModalTable, { canUpgrade: canUpgrade, filespace: filespace })] }));
};
_react_refresh_temp_1 = FilespaceDetailsWebModal;
$RefreshReg$(_react_refresh_temp_1, "FilespaceDetailsWebModal");
_react_refresh_temp_2(FilespaceDetailsWebModal, "VOAW39Z36QTD8KYe+MDTV2HKqgI=", false, () => [useFilespaceById, useFilespaceCapabilities]);
